import { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField, CircularProgress, Alert, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { updateCalendar } from '../../services/adminApiClient';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

export default function ModifyCalendarModal({ open, onClose, customer, calendarData, onSubmitSuccess }) {
    const [calendarYear, setCalendarYear] = useState('');
    const [status, setStatus] = useState('Active');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        // When the modal opens, populate the form with the selected calendar's data
        if (open && calendarData) {
            setCalendarYear(calendarData.year ? calendarData.year.toString() : '');
            setStatus(calendarData.status || 'Active');
        } else {
            // Reset form when modal is closed or no data is provided
            setCalendarYear('');
            setStatus('Active');
            setError('');
        }
    }, [open, calendarData]);

    const handleSubmit = async () => {
        // Validation check
        if (!calendarYear || !status) {
            setError('Please fill all required fields.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        // **FIX:** Use the 'calendarData' prop to get the ID, not 'calendar'.
        const payload = {
            calendar_id: calendarData.id,
            client_name: customer.ClientName, // <-- Added client_name
            calendar_year: parseInt(calendarYear, 10),
            status: status,
            timestamp: new Date().toISOString(), // <-- Added current timestamp
            last_updated_by: 'x-placeholder-user',
        };

        try {
            await updateCalendar(payload);
            if (onSubmitSuccess) {
                onSubmitSuccess(); // Notify the parent component of success
            }
        } catch (e) {
            setError(e.message || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">Modify Calendar</Typography>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                <Box sx={{ mt: 2 }}>
                    <TextField label="Client Name" value={customer ? customer.ClientName : 'N/A'} disabled fullWidth margin="normal" />
                    <TextField
                        label="Calendar Year"
                        value={calendarYear}
                        onChange={(e) => setCalendarYear(e.target.value)}
                        required
                        fullWidth
                        margin="normal"
                        type="number"
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField label="Timestamp" value="Will be set on submit" disabled fullWidth margin="normal" />
                    <TextField label="Last Updated By" value="x-placeholder-user" disabled fullWidth margin="normal" />
                </Box>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

